import { intlLocale } from '../i18n';

/** Країни, з якими працюємо (репатріація по Європі + основні напрямки). */
export const COUNTRIES = [
  'UA', 'MD', 'PL', 'RO', 'DE', 'AT', 'CZ', 'SK', 'HU', 'IT', 'ES', 'PT', 'FR', 'BE', 'NL', 'LU', 'DK', 'SE', 'NO',
  'FI', 'EE', 'LV', 'LT', 'IE', 'GB', 'CH', 'GR', 'BG', 'HR', 'SI', 'RS', 'ME', 'BA', 'MK', 'AL', 'CY', 'MT', 'IS',
  'GE', 'TR', 'IL', 'US', 'CA',
] as const;

let names: Intl.DisplayNames | null = null;

export function countryName(code: string | null | undefined): string {
  if (!code) return '—';
  try {
    names ??= new Intl.DisplayNames([intlLocale()], { type: 'region' });
    return names.of(code.toUpperCase()) ?? code;
  } catch {
    return code;
  }
}

export function route(origin: string | null | undefined, dest: string | null | undefined): string {
  if (!origin && !dest) return '—';
  return `${origin ? countryName(origin) : '?'} → ${dest ? countryName(dest) : '?'}`;
}

export const CURRENCIES = ['UAH', 'EUR', 'USD', 'PLN', 'MDL', 'RON', 'GBP', 'CZK', 'CHF'] as const;
